export default __webpack_public_path__ + "static/media/Gloves of the Blood God (nm).10cc912b.jpg";